<!-- <div
  class="py-4 px-3 nav flex-column nav-pills settings-nav align-items-start position-relative"
  id="v-pills-tab"
  role="tablist"
  aria-orientation="vertical"
>
  <a
    class="nav-link text-color-theme active"
    id="Requests-table-tab"
    data-toggle="pill"
    href="#RequestsTable"
    role="tab"
    aria-selected="false"
    [routerLink]="['/requests-analysis/requests-table']"
  >
    <img src="./assets/img/requests-icon.svg" alt="" />
    <span class="mx-3">{{ "All-Requests" | translate }}</span>
  </a>
  <a
    class="nav-link text-color-theme"
    id="Requests-tab"
    data-toggle="pill"
    href="#Requests"
    role="tab"
    aria-selected="false"
    [routerLink]="['/requests-analysis/requests']"
  >
  <img src="./assets/img/requests-icon.svg" alt="" /><i class="fas fa-plus"></i>
    <span class="mx-3">{{ "New-Requests" | translate }}</span>
  </a>
  <a
    class="nav-link text-color-theme"
    data-toggle="pill"
    [routerLink]="['/requests-analysis/research-guide']"
    role="tab"
    aria-selected="false"
  >
    <img src="./assets/img/research-guide-icon.svg" alt="" />
    <span class="mx-3">{{ "RESEARCH_GUIDE" | translate }}</span>
  </a>


  <div
    class="w-100 nav-bottom text-highlight-company-color d-flex align-items-center justify-content-between p-2"
  >
    <div class="d-flex align-items-center">
      <div class="IPO-card-logo-container d-flex align-item-center">
        <img class="avatar" src="assets/img/male-fund-avatar.svg" alt="" />
      </div>
      <div class="mx-1">
        <div class="text-color-theme font-medium font-600">{{ username }}</div>
        <div class="text-color-theme font-small">{{ currentTime }}</div>
      </div>
    </div>
    <img
      class="img-w-h"
      (click)="logout()"
      style="width: 30px"
      src="../../../../assets/img/logout.png"
    />
  </div>
</div> -->

<div class="sidebar">
  <h5 *ngIf="moduleName == 'client-institution'" class="sidebar-header p-3 mb-3 text-start font-600 ">{{'client-institution' | translate}}</h5>
  <h5 *ngIf="moduleName == 'requests-analysis'" class="sidebar-header p-3 mb-3 text-start font-600 ">{{'requests-analysis' | translate}}</h5>
  <ul class="nav-pills  d-flex flex-xl-column flex-lg-column flex-md-row flex-sm-row flex-xs-row justify-content-between mx-2">
    <ng-container *ngIf="moduleName == 'requests-analysis'">
      <li class="nav-item">
        <a
        class="nav-link text-color-theme  radius-20 "
        routerLinkActive="active IPO-selected-card-item"
        id="Requests-table-tab"
        data-toggle="pill"
        href="#RequestsTable"
        role="tab"
        aria-selected="false"
        [routerLink]="['/requests-analysis/requests-table']"
      >
        <img  src="./assets/img/requests-icon.svg" alt="" />
        <span class="mx-3 side-nav-tab">{{ "All-Requests" | translate }}</span>
      </a>
      </li>
      <li class="nav-item">
        <a
        routerLinkActive="active IPO-selected-card-item"
        class="nav-link text-color-theme  radius-20 "
        id="Requests-tab"
        data-toggle="pill"
        href="#Requests"
        role="tab"
        aria-selected="false"
        [routerLink]="['/requests-analysis/requests']"
      >
      <img src="./assets/img/requests-icon.svg"  alt="" /><i class="fas fa-plus"></i>
        <span  class="mx-3 side-nav-tab">{{ "New-Requests" | translate }}</span>
      </a>
      </li>  
        <li class="nav-item">
          <a
          class="nav-link text-color-theme  radius-20 "
        routerLinkActive="active IPO-selected-card-item"
          data-toggle="pill"
          [routerLink]="['/requests-analysis/research-guide']"
          role="tab"
          aria-selected="false"
        >
          <img src="./assets/img/research-guide-icon.svg"  alt="" />
          <span class="mx-3 side-nav-tab">{{ "RESEARCH_GUIDE" | translate }}</span>
        </a>
      
      </li>
    </ng-container>
    
    <ng-container *ngIf="moduleName == 'client-institution'">
      <li class="nav-item">
        <a
        class="nav-link text-color-theme  radius-20 "
        routerLinkActive="active IPO-selected-card-item"
        id="broker-hub-tab"
        data-toggle="pill"
        href="#BrokerHub"
        role="tab"
        aria-selected="false"
        [routerLink]="['/client-institution/brokers-hub']"
      >
        <img  src="./assets/img/requests-icon.svg" alt="" />
        <span class="mx-3 side-nav-tab">{{ "broker_hub" | translate }}</span>
      </a>
      </li>
      <li class="nav-item">
        <a
        routerLinkActive="active IPO-selected-card-item"
        class="nav-link text-color-theme  radius-20 "
        id="stock-institution-tab"
        data-toggle="pill"
        href="#StockInstitution"
        role="tab"
        aria-selected="false"
        [routerLink]="['/client-institution/stock-institution']"
      >
      <!-- <svg class="icon-color" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" baseProfile="full" enable-background="new 0 0 76.00 76.00" xml:space="preserve" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-opacity="1" stroke-width="0.2" stroke-linejoin="round" d="M 15.8332,47.5002L 15.8332,40.1901L 25.3332,31.6669L 30.0832,36.4169L 34.8331,20.5836L 44.3331,31.6669L 50.6664,25.3336L 45.9164,20.5836L 58.583,20.5836L 58.583,33.2502L 53.8331,28.5003L 44.3331,38.0002L 36.4165,28.5003L 31.6665,44.3335L 25.3332,38.0002L 15.8332,47.5002 Z "></path> <path  fill-opacity="1" stroke-width="0.2" stroke-linejoin="round" d="M 58.5833,55.4167L 53.8333,55.4167L 53.8333,34.8333L 58.5833,39.5833L 58.5833,55.4167 Z M 49.0833,55.4167L 44.3333,55.4167L 44.3333,44.3333L 49.0833,39.5834L 49.0833,55.4167 Z M 39.5833,55.4167L 34.8333,55.4167L 34.8333,45.9167L 37.2083,36.4167L 39.5833,39.5833L 39.5833,55.4167 Z M 30.0833,55.4167L 25.3333,55.4167L 25.3333,44.3333L 30.0833,49.0833L 30.0833,55.4167 Z M 20.5833,55.4167L 15.8333,55.4167L 15.8333,53.8334L 20.5833,49.0834L 20.5833,55.4167 Z "></path> </g></svg> -->
      
      <img src="./assets/img/requests-icon.svg"  alt="" />
        <span  class="mx-3 side-nav-tab">{{ "stock-institution" | translate }}</span>
      </a>
      </li>  
        <li class="nav-item">
          <a
          class="nav-link text-color-theme  radius-20 "
          routerLinkActive="active IPO-selected-card-item"
          id="fund-institution-tab"
          data-toggle="pill"
          href="#Fundinstitution"
          [routerLink]="['/client-institution/fund-institution']"
          role="tab"
          aria-selected="false"
        >
        <!-- <svg class="fund-icon-size icon-color" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 36.149 36.149" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M17.848,7.822c-0.127-0.007-0.19-0.01-0.199-0.01c-0.785,0-1.178-0.327-1.178-0.981c0-0.625,0.394-0.938,1.184-0.938 l0.193-0.006V7.822L17.848,7.822z M30.964,13.828v14.881l-12.889,7.44L5.186,28.71V13.828l5.209-3.007 c-0.266-0.81-0.413-1.672-0.413-2.571c0-4.557,3.694-8.25,8.25-8.25c4.555,0,8.25,3.693,8.25,8.25c0,0.955-0.172,1.868-0.471,2.721 L30.964,13.828z M15.039,10.093c0,0.797,0.192,1.356,0.574,1.679c0.381,0.321,1.043,0.482,1.981,0.482l0.254,0.006v0.883h0.898 V12.26l0.271-0.006c0.942,0,1.604-0.168,1.983-0.504c0.378-0.337,0.568-0.921,0.568-1.755c0-0.775-0.176-1.308-0.521-1.598 c-0.35-0.292-1.018-0.464-2.008-0.52l-0.297-0.012V5.893h0.209c0.729,0,1.096,0.292,1.096,0.877l0.006,0.142h1.289V6.73 c0-0.775-0.186-1.305-0.551-1.589c-0.367-0.286-1.051-0.428-2.049-0.428V3.945h-0.898v0.768c-1.045,0-1.762,0.149-2.146,0.447 c-0.387,0.297-0.58,0.851-0.58,1.658c0,0.833,0.193,1.402,0.577,1.707c0.384,0.303,1.101,0.454,2.149,0.454v2.139l-0.199-0.004 c-0.535,0-0.883-0.07-1.036-0.212c-0.155-0.141-0.234-0.454-0.234-0.94V9.825h-1.333L15.039,10.093z M17.075,21.573l-9.889-5.708 v11.689l9.889,5.709V21.573z M18.075,19.842l9.65-5.572l-2.596-1.499c-1.477,2.245-4.014,3.73-6.896,3.73 c-2.943,0-5.52-1.546-6.979-3.865l-2.828,1.633L18.075,19.842z M28.964,15.866l-9.89,5.707v11.69l9.89-5.709V15.866z M20.221,10.015c0-0.403-0.096-0.667-0.285-0.795c-0.189-0.127-0.586-0.192-1.188-0.192v2.089h0.189 C19.794,11.117,20.221,10.749,20.221,10.015z"></path> </g> </g></svg> -->

          <img src="./assets/img/research-guide-icon.svg"  alt="" />
          <span class="mx-3 side-nav-tab">{{ "fund-institution" | translate }}</span>
        </a>
      
      </li>
    </ng-container>

    <div
    class="w-100 nav-bottom text-highlight-company-color d-flex align-items-center justify-content-between py-2"
  >
    <div class="d-flex align-items-center user">
      <div style="margin: 0px 4x 0px 4x;" class="IPO-card-logo-container d-flex align-item-center">
        <img  class="avatar" style=" width: 50px; height: 45px;" src="assets/img/male-fund-avatar.svg" alt="" />
      </div>
      <div class="mx-2 text-start " >
        <div class="text-color-theme font-medium font-600">{{ username }}</div>
        <div class="text-color-theme font-small">
          <span>
            {{ nowDate | date : "dd-MM-YYYY" }}
          </span>
          <br>
          <span>
            {{ nowTime$ | async | clockTime: lang : false  }}
          </span>
        </div>
      </div>
    </div>
    <img
      class="img-w-h"
      (click)="logout()"
      style="width: 30px; "
      src="../../../../assets/img/logout.png"
    />
  </div>

  </ul>
</div>